import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { FormInput } from '../../components/FormInput';
import { useTranslation } from 'react-i18next';
import PrimeTableFooter from '../../components/PrimeTableFooter';
import NoInfo from '../../components/NoInfo';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { queryFeFunctionsList } from '../../utility/service/funclist-service';
import { checkDpSuccess } from '../../utility/service/tool-service';
import { SystemLoading,checkLoading } from '../../store/loadingStore'; 

const FuncList_Index = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [rows,setRows] = useState([]);
    const [,loading] = useContext(SystemLoading);

    const esgClientId = [
      {
          label:t('company.a'),
          value:'A'
      },
      {
          label:t('company.b'),
          value:'B'
      },
      {
          label:t('company.m'),
          value:'M'
      },
  ]


    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            keywordSearch:''
        },
        //錯誤驗證時機
        mode: "all"
      });

    const onSubmit = (data)=>{
        let reqBody = {
          keywordSearch:data.keywordSearch
        }
        axios_queryFeFunctionsList(reqBody);
        
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

     //查詢更多
    const btnReadMore = () => {
      
    };

    const editItem = (item)=>{
      setItemObj(item);
      navigate("detail");
      setAction("detail");
    }

    const editRole = (item)=>{
      setItemObj(item);
      navigate("roledetail");
      setAction("roledetail");
    }

    const transUseType = (input) =>{
      const values = input?.split('|');
      // 創建一個映射從 value 到 label
      const valueToLabel = esgClientId?.reduce((acc, item) => {
          acc[item.value] = item.label;
          return acc;
      }, {});
      // 根據值映射標籤
      const labels = values?.map(value => valueToLabel[value]);
      const result = labels?.join('|');
      return result;
  }
  
  // 身分別轉換
  const useTypeBodyTemplate = (rowData, props)=>{
      if(rowData){
          return (
          <>
          {transUseType(rowData?.useTypes)}
          </>)
      }
  }

    useEffect(()=>{
      axios_queryFeFunctionsList();
    },[])

    const axios_queryFeFunctionsList = (reqBody,readMore=false)=>{
      checkLoading(loading);
      queryFeFunctionsList(reqBody)
      .then((res)=>{
          if(checkDpSuccess(res)){
              let data = res?.data?.RespBody?.funcList;
              if(data?.length > 0){
                  if(readMore===true){
                    setRows((pre)=>{
                      return [...pre,...data] 
                    })
                  }else{
                    setRows((pre)=>{
                      return [...data]
                    });
                  }
                }else{
                  if(readMore===false){
                    setRows([]);
                  }
                }
              
          }else{
              if(readMore===false){
                setRows([]);
              }
            }
      }).finally((fin)=>{checkLoading(loading,false);})
  }



    const enableBodyTemplate = (rowData, props)=>{
        if(rowData){
            return (
            <>
            {
                rowData?.enable==='Y'?<span className="p-tag p-tag-success">{t('enable')}</span>:<span className="p-tag p-tag-danger">{t('disable')}</span>
            }
            </>)
        }
    } 



    const actionBodyTemplate = (rowData, props) => {
        if (rowData) {
          return (
            <>
               
                <Button tooltip={t('button.detail')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { editItem(rowData) }}>
                  <FontAwesomeIcon icon="fa-solid fa-eye" />
                </Button>
                <Button tooltip={t('button.roleMapping')} tooltipOptions={{ position: 'top' }} rounded text severity="secondary" className="p-button-icon-only" onClick={() => { editRole(rowData) }}>
                  <FontAwesomeIcon icon="fa-solid fa-user" />
                </Button>
            </>
    
          )
    
        }
      }

  return (
    <>
    <div className="p-card bg-gray">
        <div className="p-card-body">
            <form className="flex flex-wrap align-items-center col-12" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
            <div className="col-12 lg:col-9">
              <FormInput
                register={register}
                errors={errors}
                id="keywordSearch"
                type="text"
                placeholder={`${t('funcId')}、${t('fun_name')}`}
                labelClass="control-label"
                enterClick={checkKeyDown}
                labelText={t('keyword')}
                
              />
            </div>
            <div className="col-12 lg:col-3 gap-2 mt-4">
                <Button type="submit" label={t("button.query")} />
            </div>


            </form>
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: '55rem' }}
            value={rows}
            footer={rows.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={false} btnReadMore={btnReadMore} />}
            emptyMessage={<NoInfo panel="table"/>}
            >
                <Column field="funcId" header={t('funcId')} />
                <Column field="name"  header={t('fun_name')} />
                <Column field="useTypesName"  header={t('authorization')} />
                <Column field="funcOrder" header={t('order')} />
                <Column field="enable"  header={t('status')} body={enableBodyTemplate} />
                <Column style={{ width: 'auto' }} body={actionBodyTemplate} header={t('action')} frozen alignFrozen="right" />
            </DataTable>
        </div>

    </div>
    </>
    
  )
}

export default FuncList_Index